module.exports = __webpack_public_path__ + "img/Tablet - 1.60095511.png";